export default "__VITE_ASSET__Q0VJ6gGd__"